import type {
  MemberAccountDetailsResponse,
  MemberChangePasswordRequest,
  MemberLoginRequest,
  MemberLoginResponse,
  MemberRegisterRequest,
  MemberRegisterResponse,
  RequestResetPassword,
} from "@features/authentication/types";

import { api } from "@services/api";
import { decryptData, encryptData } from "@shared/utils/encryption";

export class AuthService {
  private readonly basePath = "/member";
  private readonly publicPath = "/public/member";

  // Change password method
  public async changePassword(
    data: MemberChangePasswordRequest,
  ): Promise<MemberAccountDetailsResponse> {
    return await api.post<MemberAccountDetailsResponse>(
      `${this.basePath}/account/change/secret`,
      data,
    );
  }

  // Login method
  public async login(credentials: MemberLoginRequest): Promise<MemberLoginResponse> {
    return await api.post<MemberLoginResponse>(`${this.basePath}/login`, credentials);
  }

  // Register method
  public async register(credentials: MemberRegisterRequest): Promise<MemberRegisterResponse> {
    return await api.post<MemberRegisterResponse>(`${this.basePath}/signup`, credentials);
  }

  // Request reset password method
  public async requestResetPassword(data: {
    member_email: string;
    timestamp: string;
  }): Promise<RequestResetPassword> {
    const response = await api.post<{ data: string }>(
      `${this.publicPath}/account/request/reset/secret`,
      {
        data: await encryptData({
          member_email: data.member_email,
          timestamp: data.timestamp,
        }),
      },
    );

    return await decryptData<RequestResetPassword>(response.data);
  }

  // Verify Reset Password
  public async verifyResetPassword(data: {
    member_email: string;
    member_secret_new: string;
    timestamp: string;
    token: string;
  }): Promise<RequestResetPassword> {
    const response = await api.post<{ data: string }>(
      `${this.publicPath}/account/verify/reset/secret`,
      {
        data: await encryptData({
          member_email: data.member_email,
          member_secret_new: data.member_secret_new,
          timestamp: data.timestamp,
          token: data.token,
        }),
      },
    );

    return await decryptData<RequestResetPassword>(response.data);
  }
}

export const authService = new AuthService();
